import styled from "styled-components";

export const StyledCheckbox = styled.div`
	& span {
		height: 1.6rem;
		width: 1.6rem;
		margin: 1px;

		display: block;
		border: 1px solid white;
		border-radius: 1px;
		outline: 1px solid black;

		position: relative;

		cursor: pointer;

		&::after {
			height: 1rem;
			width: 1rem;

			display: none;
			content: "";
			position: absolute;
			top: 50%;
			left: 50%;

			background-color: black;

			transform: translate(-50%, -50%);
		}

		&.checked::after {
			display: block;
		}
	}

	& input {
		visibility: hidden;
		position: absolute;
	}
`;
